/** Callback invoked when a Telerik RadWindow popup is closed. */
export type PopupCloseCallback = (sender: Telerik.Web.UI.RadWindow, args: Telerik.Web.UI.WindowCloseEventArgs) => void;
/** Callback invoked when a Telerik RadWindow popup is opened. */
export type PopupOpenCallback = (sender: Telerik.Web.UI.RadWindow, args: Sys.EventArgs) => void;

/** Configuration for opening a popup window (URL, params, title, sizing, and close callback). */
export class PopupProperties {
    url: string;
    params?: any;
    title: string;
    width?: string;
    height?: string;
    callback?: PopupCloseCallback;
    windowName?: string;

    /**
     * Creates a PopupProperties instance with default height and width of 75%.
     */
    constructor() {
        this.height = "75%";
        this.width = "75%";
    }
}
